// extracted by mini-css-extract-plugin
module.exports = {"copy":"stats-section_copy__3as9x","preheader":"stats-section_preheader__n2FrE","description":"stats-section_description__k9hPK"};